import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';
import queryString from 'query-string';
import {Link} from 'react-router-dom';

//import components
import LoadingIndicatorText from '../components/LoadingIndicatorText.js';
import ItemBreadcrumbs from '../components/items/ItemBreadcrumbs.js';
import Error404 from './Error-404.js';
import SimpleSearchResults from './SimpleSearchResults.js';
import DetailsDesc from '../components/characteristics-details/DetailsDesc.js';
import DetailsLocation from '../components/characteristics-details/DetailsLocation.js';

import fieldRed from '../assets/icons/field-red.svg';
import fieldGreen from '../assets/icons/field-green.svg';
import fieldYellow from '../assets/icons/field-yellow.svg';
import fieldViolet from '../assets/icons/field-violet.svg';

//import helper methods
import withTitle from '../scripts/WithTitle.js';

class CharacterHeadingsDetails extends Component {
    constructor() {
        super();

        this.state = {
            initialized: false,
            isTouched: false
        };
    };

    componentDidMount() {
        const {actions, location, rootsData} = this.props;
        const query = queryString.parse(location.search, {arrayFormat: 'index'});

        if (!query.HEADINGS || !query.HEADINGS[0]) {
            return;
        }

        actions.getHeadingDetails(query.HEADINGS[0]);

        if (!rootsData) {
            actions.getHeadingsRoots();
        }
    };

    componentDidUpdate(prevProps, prevState) {
        const {detailsData, isFetching, rootsData, isLoadingRoots, actions, location} = this.props;
        const {initialized, isTouched} = this.state;
        const query = queryString.parse(location.search, {arrayFormat: 'index'});
        const prevQuery = queryString.parse(prevProps.location.search, {arrayFormat: 'index'});

        if (query.HEADINGS[0] !== prevQuery.HEADINGS[0]) {
            this.resetIsTouched();
            actions.getHeadingDetails(query.HEADINGS[0]);
        }

        if (detailsData && (!prevProps.detailsData || (detailsData.id !== prevProps.detailsData.id))) {
            actions.getHeadingChildrenReversed(detailsData.domainCode, query.HEADINGS[0]);
        }

        if (detailsData && rootsData && !isFetching && !isLoadingRoots && !initialized) {
            this.setState({initialized: true});
        }

        if (!isTouched && rootsData && (rootsData !== prevProps.rootsData)) {
            const currentDomain = rootsData && detailsData ? rootsData.filter(root => root.domainCode === detailsData.domainCode)[0] : {};

            this.setState({rootsPath: currentDomain && currentDomain.children ?
                                        [currentDomain].concat(this.getRootsPath(currentDomain.children, query.HEADINGS[0]))
                                        : [currentDomain]});
        }
    };

    getRootsPath = (currentDomain, newHeading) => {
        const newArr = [];

        const addRoot = (arr) => {
            arr.forEach(function(root) {
                if (root.children || (root.id === newHeading)) {
                    newArr.push({domainCode: root.domainCode, id: root.id, label: root.label});
                }

                if (root.children) {
                    addRoot(root.children);
                }
            });
        }

        addRoot(currentDomain);
        return newArr;
    };

    getImgField = (label) => {
        switch (label) {
            case 'literature-theory':
                return <img src={fieldViolet} alt="" />;
            case 'polish-literature':
                return <img src={fieldRed} alt="" />;
            case 'foreign-literature':
                return <img src={fieldYellow} alt="" />;
            case 'movie-theatre-rtv':
                return <img src={fieldGreen} alt="" />;
            default:
                return;
        }
    };

    getFieldChildren = (id) => {
        const {actions} = this.props;

        actions.getFieldChildren(id);
    };

    setIsTouched = () => {
        this.setState({isTouched: true});
    };    
    
    resetIsTouched = () => {
        this.setState({isTouched: false});
    };

    render() {
        const {clang, showBackButton, isMobile, rootsData, isMobileSmall, location, detailsData, isLoadingHeadingChildren, isLoadingHeadingChildrenError, previousLocation, isLoadingError, isLoadingRootsError} = this.props;
        const {initialized, isTouched, rootsPath} = this.state;
        const query = queryString.parse(location.search, {arrayFormat: 'index'});

        if (!query.HEADINGS || !query.HEADINGS[0]) {
            return <Error404 />;
        }

        const breadcrumbsList = [
                  {label: 'home'},
                  {label: 'headings', link: '/headings/about'},
                  {label: 'headings_about', link: '/headings/about'},
                  detailsData ? {label: detailsData.domainCode, link: `/headings/about#${detailsData.domainCode}`} : false,
              ];

        return (
            <section className="headings-details">
                <ItemBreadcrumbs list={breadcrumbsList} currentPage={detailsData ? detailsData.label : false}/>

                {!initialized && !isLoadingError &&
                    <div>
                        <LoadingIndicatorText />
                    </div>}

                {initialized && !isLoadingError &&
                    <div>
                        <div className="headings-details__header">
                            {previousLocation &&
                                <div className="back-button__container">
                                    <Link to={`${previousLocation.pathname}${previousLocation.search}`} className="back-button">
                                        <span className="back-button__img"></span>
                                        {lang[clang].back}
                                    </Link>
                                </div>}
                            <h5 className="headings-details__name">
                                {this.getImgField(detailsData.domainCode)}
                                {detailsData.label}
                            </h5>
                            <span className="headings-details__meta-data">{lang[clang].item.cards.card_id}: <strong>{query.HEADINGS[0]}</strong></span>
                        </div>

                        <div className="headings-details__desc">
                            <DetailsDesc detailsData={detailsData} />
                            {!isLoadingRootsError &&
                                <DetailsLocation
                                    getImgField={this.getImgField}
                                    setIsTouched={this.setIsTouched}
                                    getFieldChildren={this.getFieldChildren}
                                    isTouched={isTouched}
                                    rootsPath={rootsPath}
                                    rootsData={rootsData}
                                    currentHeading={query.HEADINGS[0]}
                                    isLoading={!!isLoadingHeadingChildren[detailsData.domainCode]}
                                    isError={!!isLoadingHeadingChildrenError[detailsData.domainCode]}
                                    detailsData={detailsData}/>}
                        </div>
                    </div>}

                <SimpleSearchResults showBackButton={showBackButton} isMobile={isMobile} isMobileSmall={isMobileSmall}/>
            </section>
        );
    };
};

CharacterHeadingsDetails.propTypes = {
    actions: propTypes.object.isRequired,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    detailsData: state.headingDetails.detailsData,
    isFetching: state.headingDetails.isFetching,
    isLoadingError: state.headingDetails.isLoadingError,
    rootsData: state.characteristics.rootsHeadingsData,
    isLoadingRoots: state.characteristics.isFetchingHeadingsRoots,
    isLoadingRootsError: state.characteristics.isLoadingErrorHeadingsRoots,
    isLoadingHeadingChildren: state.characteristics.isFetchingHeadingChildren,
    isLoadingHeadingChildrenError: state.characteristics.isLoadingErrorHeadingChildren,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(CharacterHeadingsDetails);



// WEBPACK FOOTER //
// ./src/containers/CharacterHeadingsDetails.js